import * as React from 'react'
import { Block } from './library/container'

export type QuoteBlockProps = {
  quote: string
  source?: string
}

export const QuoteBlock: (props: QuoteBlockProps) => JSX.Element = props => (
  <Block>
    <div className="quote">
      <h2 className="quote__text">{props.quote}</h2>
      {props.source && (
        <div className="quote__name">{props.source}</div>
      )}
    </div>
  </Block>
)
